<template>
  <nav class="bg-indigo-700">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <img
              class="h-8"
              src="@/assets/logo.png"
              alt="Workflow logo"
            >
          </div>
          <div class="hidden md:block">
            <div class="ml-10 flex items-baseline space-x-4">
              <router-link
                v-for="{ to, text, active } in links"
                :key="text"
                :to="to"
                :class="active ? 'text-white bg-indigo-800' : 'text-indigo-200 hover:text-white hover:bg-indigo-600'"
                class="px-3 py-2 rounded-md text-sm font-medium focus:outline-none focus:text-white focus:bg-indigo-600"
                v-text="text"
              />
            </div>
          </div>
        </div>
        <Search />
        <div class="-mr-2 flex md:hidden">
          <!-- Mobile menu button -->
          <button
            class="inline-flex items-center justify-center p-2 rounded-md text-indigo-300 hover:text-white hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600 focus:text-white"
            @click="toggleMobileMenu"
          >
            <svg
              :class="mobileMenuShown ? 'hidden' : 'block'"
              class="h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              :class="mobileMenuShown ? 'block' : 'hidden'"
              class="h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div
      v-show="mobileMenuShown"
      class="md:hidden"
    >
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <router-link
          v-for="{ to, text, active } in links"
          :key="text"
          :to="to"
          :class="active ? 'text-white bg-indigo-800' : 'text-indigo-200 hover:text-white hover:bg-indigo-600'"
          class="block px-3 py-2 rounded-md text-base font-medium focus:outline-none focus:text-white focus:bg-indigo-600"
          v-text="text"
        />
      </div>
    </div>
  </nav>
</template>
<script lang="ts">
import Search from '@/components/Search.vue'
import { useToogle } from '@/hooks/commons'
import { groups } from '@/config'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'NavBar',
  components: { Search },
  setup() {
    const [mobileMenuShown, toggleMobileMenu] = useToogle()
    const route = useRoute()

    const links = computed(() => [
      {
        text: 'Tous',
        to: { query: { } },
        active: !route.query.group,
      },
      ...groups.map(({ shortTitle, key }) => ({
        text: shortTitle,
        to: { query: { group: key } },
        active: key === route.query.group,
      })),
    ])

    return {
      mobileMenuShown,
      toggleMobileMenu,
      links,
    }
  },
}
</script>
